import { create } from 'zustand';
import { authService } from '../services/authService';

export const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  error: null,
  
  // Initialize auth state
  initialize: async () => {
    try {
      if (authService.isAuthenticated()) {
        const user = await authService.getCurrentUser();
        set({ user, isAuthenticated: true, isLoading: false });
      } else {
        set({ isLoading: false });
      }
    } catch (error) {
      set({ isLoading: false, error: error.message });
    }
  },
  
  // Login
  login: async (credentials) => {
    try {
      set({ isLoading: true, error: null });
      const data = await authService.login(credentials);
      set({ user: data.user, isAuthenticated: true, isLoading: false });
      return data;
    } catch (error) {
      set({ isLoading: false, error: error.message });
      throw error;
    }
  },
  
  // Register
  register: async (userData) => {
    try {
      set({ isLoading: true, error: null });
      const data = await authService.register(userData);
      set({ user: data.user, isAuthenticated: true, isLoading: false });
      return data;
    } catch (error) {
      set({ isLoading: false, error: error.message });
      throw error;
    }
  },
  
  // Logout
  logout: () => {
    authService.logout();
    set({ user: null, isAuthenticated: false });
  },
  
  // Clear error
  clearError: () => set({ error: null }),
}));




